import React from 'react';

const IconQuestionMark = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#D7DCEB" />
      <path
        d="M15.9649 10.2012C17.0742 10.2012 17.9649 10.5052 18.6369 11.1132C19.3195 11.7105 19.6609 12.5372 19.6609 13.5932C19.6609 14.6385 19.3249 15.4385 18.6529 15.9932C17.9809 16.5372 17.0902 16.8092 15.9809 16.8092L15.9169 18.0412H13.9489L13.8689 15.3212H14.5889C15.5169 15.3212 16.2315 15.1985 16.7329 14.9532C17.2342 14.7078 17.4849 14.2598 17.4849 13.6092C17.4849 13.1398 17.3462 12.7665 17.0689 12.4892C16.8022 12.2118 16.4342 12.0732 15.9649 12.0732C15.4742 12.0732 15.0902 12.2065 14.8129 12.4732C14.5462 12.7398 14.4129 13.1078 14.4129 13.5772H12.3009C12.2902 12.9265 12.4289 12.3452 12.7169 11.8332C13.0049 11.3212 13.4262 10.9212 13.9809 10.6332C14.5462 10.3452 15.2075 10.2012 15.9649 10.2012ZM14.9249 21.8652C14.5195 21.8652 14.1835 21.7425 13.9169 21.4972C13.6609 21.2412 13.5329 20.9265 13.5329 20.5532C13.5329 20.1798 13.6609 19.8705 13.9169 19.6252C14.1835 19.3692 14.5195 19.2412 14.9249 19.2412C15.3195 19.2412 15.6449 19.3692 15.9009 19.6252C16.1569 19.8705 16.2849 20.1798 16.2849 20.5532C16.2849 20.9265 16.1569 21.2412 15.9009 21.4972C15.6449 21.7425 15.3195 21.8652 14.9249 21.8652Z"
        fill="white"
      />
    </svg>
  );
};

export default IconQuestionMark;
